const rank = [
    { field: "region", value: 8 },
    { field: "is_autistic_spectrum", value: 2 },
    { field: "is_intellectual_limitation", value: 2 },
    { field: "is_delayed_developed", value: 2 },
    { field: "is_physical_limitation", value: 2 },
    { field: "is_behavioral_difficulty", value: 2 },
    { field: "is_nursing_assistance", value: 2 },
    { field: "iis_medical_assistance", value: 2 },
    { field: "work_on_sunday", value: 1 },
    { field: "work_on_monday", value: 1 },
    { field: "work_on_tuesday", value: 1 },
    { field: "work_on_wednesday", value: 1 },
    { field: "work_on_thursday", value: 1 },
    { field: "work_on_friday", value: 1 },
    { field: "work_on__saturday", value: 1 },
];

const cityScore = 14;

exports.rank =rank;
exports.cityScore = cityScore;